import React, { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import AuthModal from "@/components/AuthModal";
import { toast } from "sonner";
import { Trophy } from "lucide-react";

export default function ClaimBox({ shortId, isGuestCall, onClaimed }) {
  const { user } = useAuth();
  const [authOpen, setAuthOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const claimed = useRef(false);
  const token = sessionStorage.getItem(`claim_${shortId}`);

  const doClaim = async () => {
    if (claimed.current) return;
    if (!token) return toast.error("Claim code not found on this device");
    setBusy(true);
    try {
      await api.post(`/calls/${shortId}/claim`, { claim_token: token });
      claimed.current = true;
      sessionStorage.removeItem(`claim_${shortId}`);
      sessionStorage.removeItem("pending_claim");
      toast.success("🏆 Call claimed — it's on your track record!");
      onClaimed?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not claim");
    } finally {
      setBusy(false);
    }
  };

  // Auto-claim after returning from OAuth sign-in
  useEffect(() => {
    if (user && token && !claimed.current && sessionStorage.getItem("pending_claim") === shortId) {
      doClaim();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  if (!isGuestCall || !token) return null;

  const start = () => {
    if (user) doClaim();
    else { sessionStorage.setItem("pending_claim", shortId); setAuthOpen(true); }
  };

  return (
    <div data-testid="claim-box" className="card-brutal p-6 bg-locked text-ink">
      <h3 className="font-display text-2xl font-bold flex items-center gap-2">
        <Trophy className="w-6 h-6" strokeWidth={2.5} /> Want credit when you're right?
      </h3>
      <p className="text-sm mt-1 mb-4">Claim this Call and start your permanent track record.</p>
      <button data-testid="claim-btn" disabled={busy} onClick={start}
        className="h-12 px-6 border-2 border-ink bg-ink text-white font-bold btn-press shadow-brutal-sm">
        {busy ? "Claiming…" : "Claim this Call"}
      </button>
      <AuthModal open={authOpen} onOpenChange={setAuthOpen} title="Claim your Call" />
    </div>
  );
}
